import React from 'react';
import MuiCircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export type { CircularProgressProps };

export const CircularProgress: React.FC<CircularProgressProps> = (props) => (
  <MuiCircularProgress {...props} />
);
